import { render } from "./NotRegister.vue?vue&type=template&id=ae65db76"
import script from "./NotRegister.vue?vue&type=script&lang=js"
export * from "./NotRegister.vue?vue&type=script&lang=js"

import "./NotRegister.vue?vue&type=style&index=0&id=ae65db76&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__